export const tr = {
    'no-rights': 'Öneriyi uygulama yetkiniz yok',
    'progress-title': 'Öneri uygulanıyor...'
};
